export default "__VITE_ASSET__CDgkSTgT__"